














import { Component, Vue } from 'vue-property-decorator'

@Component
export default class UserDrawer extends Vue {
  drawer: boolean = false

  get accountEmail (): string {
    return this.$store.state.account.auth.email
  }

  toggle () {
    this.drawer = !this.drawer
  }
}
